/**
 * 漫剧用户端 sessionStorage 键与派生规则集中定义，避免多页字符串漂移。
 * 与 ProjectSetupPage.ssKey / StoryboardEditorPage 分集缓存逻辑保持一致。
 */

/** 首页「我的项目」列表 */
export const HOME_PROJECTS_CACHE_KEY = "home_projects_cache";

/** 步骤二/三各列表在未绑定项目 id 时的 key 前缀（有 id 时带后缀 _{projectId}） */
export function projectStepCacheKey(kind, projectId) {
  const id = Number(projectId || 0);
  if (!id) return `project_${kind}_cache`;
  return `project_${kind}_cache_${id}`;
}

/**
 * readSessionList 的第二参数：旧版全局 key，读不到带 projectId 的 key 时回退。
 */
export const LEGACY_SESSION_KEYS = {
  roles: "project_roles_cache",
  scenes: "project_scenes_cache",
  materials: "project_materials_cache",
  storyboards: "project_storyboards_cache"
};

/** 分镜编辑页 / 写回 shots 时遍历的 session key 列表（先新后旧） */
export function storyboardsStorageKeys(projectId) {
  const id = Number(projectId || 0);
  if (id > 0) {
    return [`project_storyboards_cache_${id}`, LEGACY_SESSION_KEYS.storyboards];
  }
  return [LEGACY_SESSION_KEYS.storyboards];
}

/** data() 里读分集列表的首选用 key */
export function storyboardsPrimaryCacheKey(projectId) {
  const id = Number(projectId || 0);
  return id > 0 ? `project_storyboards_cache_${id}` : LEGACY_SESSION_KEYS.storyboards;
}

/** 步骤一表单本地草稿（与 saveProjectDraft 互补） */
export function step1StateStorageKey(projectId) {
  return `project_step1_state_${Number(projectId || 0)}`;
}

/** 步骤一异步任务 id，用于刷新后继续轮询 */
export function step1TaskIdStorageKey(projectId) {
  const id = Number(projectId || 0);
  return id > 0 ? `project_step1_task_id_${id}` : "project_step1_task_id";
}
